import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import { Button, Typography } from 'antd';
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import cn from 'classnames';
import { SWAGGER_URL } from '../../api';
import PlaylistDuration from './Playlist/PlaylistDuration';
import CardImg from '@components/snippets/CardImg';

const PlaylistCard = React.memo(function PlaylistCard({
  index,
  id,
  full,
  number,
  url,
  name,
  type,
  resolution,
  largeThumb,
  smallThumb,
  duration,
  onDelete,
  onChangeDuration,
}) {
  if (process.env.NODE_ENV === 'development') {
    smallThumb = SWAGGER_URL + '/' + smallThumb;
  }

  const handleDelete = () => {
    onDelete(id, index);
  };

  const handleChangeDuration = (value) => {
    onChangeDuration(id, index, value);
  };

  return (
    <div
      className={cn('playlist-card', {
        'playlist-card--full': full,
      })}
    >
      {full && <div className="playlist-card__number">{number}</div>}
      <div className="playlist-card__image">
        <CardImg name={name} smallThumb={smallThumb} />
        {!full && (
          <div className="playlist-card__overlay">
            <div className="playlist-card__overlay-actions">
              <Button
                icon={
                  <EyeOutlined
                    className="playlist-card__icon"
                    width={24}
                    height={24}
                  />
                }
                type="link"
                ghost
              />
            </div>
          </div>
        )}
      </div>
      <div className="playlist-card__info">
        <div>
          <Typography.Paragraph
            className="playlist-card__title"
            ellipsis={{
              rows: 2,
              expandable: true,
            }}
          >
            {name}
          </Typography.Paragraph>
        </div>
        <div className="playlist-card__type">
          {type} {resolution && ', ' + resolution}
        </div>
      </div>
      {full && duration && (
        <PlaylistDuration
          readOnly={type === 'video'}
          duration={duration}
          onChange={handleChangeDuration}
        />
      )}
      {full && (
        <div className="playlist-card__actions">
          <Button
            onClick={handleDelete}
            type="link"
            ghost
            icon={<DeleteOutlined width={12} height={12} />}
          />
        </div>
      )}
    </div>
  );
});

PlaylistCard.whyDidYouRender = true;

export default PlaylistCard;
